// extracted by mini-css-extract-plugin
export default {"BetaLabel":"BooleanField-module__BetaLabel--UVSPf"};